var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13334 17.6C6.13334 18.336 6.72 18.9333 7.46667 18.9333H10.1333C10.8693 18.9333 11.4667 18.336 11.4667 17.6V8.53331C11.4667 7.78665 10.8693 7.19998 10.1333 7.19998H7.46667C6.72 7.19998 6.13334 7.78665 6.13334 8.53331V17.6ZM7.46667 17.8666C7.31734 17.8666 7.2 17.7386 7.2 17.6V8.53331C7.2 8.38398 7.31734 8.26665 7.46667 8.26665H10.1333C10.272 8.26665 10.4 8.38398 10.4 8.53331V17.6C10.4 17.7386 10.272 17.8666 10.1333 17.8666H7.46667ZM5.10934 5.58931C5.10934 5.84531 5.32267 6.06931 5.58934 6.06931H18.3893C18.6453 6.06931 18.8693 5.84531 18.8693 5.58931C18.8693 5.32265 18.6453 5.10931 18.3893 5.10931H5.57867C5.312 5.10931 5.09867 5.32265 5.09867 5.58931H5.10934ZM13.856 14.656C13.1093 14.656 12.5227 14.0586 12.5227 13.3226V8.52265C12.5227 7.77598 13.1093 7.18931 13.856 7.18931H16.5227C17.2587 7.18931 17.856 7.77598 17.856 8.52265V13.3226C17.856 14.0586 17.2587 14.656 16.5227 14.656H13.856Z",
    fill: "#9DA6AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSectionIcon);
export default __webpack_public_path__ + "static/media/section-icon.b80baba2b32ea1af7b8b89b7e958f1fd.svg";
export { ForwardRef as ReactComponent };